"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _reactSimpleMaps = require("react-simple-maps");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _GeographyTooltip = _interopRequireDefault(require("./GeographyTooltip"));

//
//  src/map/ComposableMap.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 11/12/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* External Libraries */

/* Lego Toolkit */

/* Relative Imports */
var discussion = "\nBased on [`react-simple-map`](https://www.react-simple-maps.io), it should be able to support any regional \naround globe, provided the developer can is able to give it the topological dataset -- can find them online. \nUS state topology comes from public [Census Bureau dataset](https://github.com/topojson/us-atlas#readme), you can \nfind other datasets there.\n";
/* eslint-disable local-rules/unwrapped-i18n */

var propDoc = {
  geoUrl: {
    required: true,
    type: "string | ReadonlyArray<string>",
    description: "URL/URLs of the map dataset"
  },
  processGeographies: {
    required: false,
    type: "(geos: ReadonlyArray<any>) => ReadonlyArray<any>",
    description: "Preprocess and return the array of all geographies before they appear on the map"
  },
  children: {
    required: true,
    type: "(geo: any) => GeographyProps",
    description: "Return render settings for a geography on the map"
  },
  projection: {
    required: false,
    type: "string",
    description: "Project of the map"
  },
  projectionConfig: {
    required: false,
    type: "Transform",
    description: "Use this to focus on a specific area on the map/dataset"
  },
  canZoom: {
    required: false,
    type: "boolean",
    description: "Enable zoom and drag functionality on the map"
  },
  zoomProps: {
    required: false,
    type: "ZoomableGroupProps",
    description: "Additional options to configure drag/zoom functionality"
  }
};
var demoProps = {
  geoUrl: "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json",
  projection: "geoAzimuthalEqualArea",
  projectionConfig: {
    rotate: [-20.0, -52.0, 0],
    scale: 700
  },
  style: {
    width: 500,
    height: 500
  },
  children: function children(geo) {
    return {
      fill: "rgba(175, 199, 209, 0.4)"
    };
  }
};
var demoRender = "\n<ComposableMap\n  geoUrl=\"https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json\"\n  projection=\"geoAzimuthalEqualArea\"\n  projectionConfig={{\n    rotate: [-20.0, -52.0, 0],\n    scale: 700\n  }}\n  style={{\n    width: 500,\n    height: 500\n  }}\n>\n  {geo => {\n    return { fill: \"rgba(175, 199, 209, 0.4)\" };\n  }}\n</ComposableMap>\n";

var ComposableMap = function ComposableMap(props) {
  var className = props.className,
      style = props.style,
      children = props.children,
      geoUrl = props.geoUrl,
      processGeographies = props.processGeographies,
      projection = props.projection,
      projectionConfig = props.projectionConfig,
      canZoom = props.canZoom,
      zoomProps = props.zoomProps;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tooltipContent = _useState2[0],
      setTooltipContent = _useState2[1];

  var styles = useStylesheet();
  var renderer = (0, _react.useCallback)(function (_ref) {
    var geographies = _ref.geographies;
    return (// any type from GeographiesChildrenArgument
      geographies.map(function (geo) {
        var _children = children(geo),
            _children$fill = _children.fill,
            fill = _children$fill === void 0 ? "rgba(175, 199, 209, 0.4)" : _children$fill,
            _children$stroke = _children.stroke,
            stroke = _children$stroke === void 0 ? "white" : _children$stroke,
            _children$style = _children.style,
            style = _children$style === void 0 ? DefaultStyle : _children$style,
            _onClick = _children.onClick,
            renderPopover = _children.renderPopover,
            _onMouseEnter = _children.onMouseEnter,
            _onMouseLeave = _children.onMouseLeave,
            remainingProps = (0, _objectWithoutProperties2["default"])(_children, ["fill", "stroke", "style", "onClick", "renderPopover", "onMouseEnter", "onMouseLeave"]);

        return /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Geography, (0, _extends2["default"])({
          key: geo.rsmKey,
          geography: geo,
          className: (0, _styling.css)(styles.geography),
          fill: fill,
          stroke: stroke,
          style: style,
          onClick: function onClick() {
            if (_onClick) {
              _onClick();
            }
          },
          onMouseEnter: function onMouseEnter() {
            if (renderPopover != null) {
              setTooltipContent(renderPopover());
            }

            if (_onMouseEnter != null) {
              _onMouseEnter();
            }
          },
          onMouseLeave: function onMouseLeave() {
            setTooltipContent(null);

            if (_onMouseLeave != null) {
              _onMouseLeave();
            }
          }
        }, remainingProps));
      })
    );
  }, [children, setTooltipContent, styles.geography]);
  var geographies = Array.isArray(geoUrl) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, geoUrl.map(function (url) {
    return /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Geographies, {
      geography: url,
      parseGeographies: processGeographies,
      key: url
    }, renderer);
  })) : /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Geographies, {
    geography: geoUrl,
    parseGeographies: processGeographies
  }, renderer);

  if (canZoom) {
    geographies = /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.ZoomableGroup, zoomProps, geographies);
  }
  /*eslint-disable local-rules/no-dom-manipulation*/


  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.ComposableMap, {
    "data-tip": "",
    className: (0, _styling.css)(className, style),
    projection: projection,
    projectionConfig: projectionConfig
  }, geographies), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    className: (0, _styling.css)(styles.tooltip)
  }, /*#__PURE__*/_react["default"].createElement(_GeographyTooltip["default"], null, tooltipContent)));
};

ComposableMap.propDoc = propDoc;
ComposableMap.demoProps = demoProps;
ComposableMap.demoRender = demoRender;
ComposableMap.discussion = discussion;
var _default = ComposableMap;
exports["default"] = _default;
var DefaultStyle = {
  hover: {
    stroke: _providers.DefaultThemingContext.theme.corePrimary,
    strokeWidth: 2
  }
};

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      tooltip: {
        backgroundColor: "transparent",
        opacity: 1,
        padding: 0,
        margin: 0,
        fontFamily: fonts.regular
      },
      geography: {
        outline: "none",
        fontFamily: fonts.regular
      }
    });
  }, [fonts.regular]);
};